import React,{useState} from 'react'
import "./TextCard.css"

function TextCardBox({
    title,
    iconImg,
    breifPara,
    actualPara,
    listPoint
}) {
    const [dropOpen , setDropOpen] = useState(false)
  return (
    <div
      className="text-card-box p-4 px-5 d-flex flex-column align-items-start"
      onClick={() => {
        setDropOpen((prev) => !prev);
      }}
    >
      <div className="content-info d-flex gap-3 align-items-center justify-content-start my-4">
        <img src={iconImg} className="" alt='card icon'/>
        <h5 className="body-heading mb-0" style={{fontWeight:400 , fontSize:"23px"}}>{title}</h5>
      </div>
      <p
        className={`body-paragraph ${dropOpen ? "d-none" : "d-block close"}`}
      >
        {breifPara}
        {listPoint && <ul><li>{listPoint[1]}</li></ul>}
      </p>
      <p
        className={`body-paragraph ${dropOpen ? "d-block open" : "d-none "}`}
      >
        {actualPara}
        {listPoint && <ul>{listPoint.map((ele)=>{return(<li className='my-2'>{ele}</li>)})}</ul>}
      </p>
      
      <img
        src={
          dropOpen
            // ? "/images/icons/text-card-arrow-open.svg"
            ? "/images/icons/text-card-arrow-close.svg"
            : "/images/icons/text-card-arrow-close.svg"
        }
        className="align-self-end my-3"
        // style={{ cursor: "pointer" }}
        style={dropOpen
          ? {transition:".3s",transform: "rotate(190deg)"}
          : {transition:".3s",transform: "rotate(0deg)"}
        }
        alt='arrow icon'
      />
    </div>
  );
}
export function TextCardBoxCenter({
    title,
    iconImg,
    breifPara="",
    actualPara="",
    listPoint
}) {
  return (
    <div
      className="text-card-box p-4 px-5 d-flex flex-column align-items-center mx-auto mb-2"
      style={{width:"100%",background:"none",border:"3px solid #3CADE2"}}
     
    >
      <div className="content-info d-flex gap-3 align-items-center justify-content-center my-4 text-center">
        <img src={iconImg} className="" alt='card icon'/>
        <h5 className="body-heading mb-0" style={{fontWeight:400 , fontSize:"23px"}}>{title}</h5>
      </div>
     
      <p
        className={`body-paragraph d-flex flex-md-row flex-column align-items-start justify-content-evenly w-100 `}
      >
        <ul className='mb-0'>
          <li className='my-2'>We are <b>passionate.</b></li>
          <li className='my-2'><b>Creative</b> problem solving is a key competency.</li>
          <li className='my-2'><b>Integrity</b> is a key foundation.</li>
          <li className='my-2 mb-md-2 mb-0'><b>Quality</b> is a hallmark of our work.</li>
        </ul>
        <ul>
          <li className='my-2'>We are  a <b>collaborative</b> team.</li>
          <li className='my-2'><b>Innovation</b> is key to our success.</li>
          <li className='my-2'>We are <b>customer focused.</b></li>
        </ul>
      </p>
    </div>
  );
}

export default TextCardBox